<template>
  <a-modal
    title="要货单拆分供应商"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    okText="确认拆分"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="font-bold">拆分前：</div>
    <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item label="组织">
            <a-input v-model="detail.organizationName" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="要货单号">
            <a-input v-model="detail.deliveryNotice" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item label="物料编码">
            <a-input-group compact>
              <a-input v-model="detail.itemCode" disabled class="w150" />
              <a-input v-model="detail.itemName" disabled class="w150" />
              <a-input v-model="detail.specification" :title="detail.specification" disabled class="w150" />
            </a-input-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item label="要求到货日期">
            <a-input v-model="detail.needByDate" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="单位">
            <a-input v-model="detail.uom" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="需求数量">
            <a-input v-model="detail.quantity" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="供应商">
            <a-input v-model="detail.supplierName" disabled />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item label="MPQ">
            <a-input v-model="detail.fixedLotMultiplier" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="拆分后总数量">
            <a-input v-model="detail.quantityTotal" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="待送货量">
            <a-input v-model="detail.quantityPendingShipment" disabled />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="font-bold">拆分后：</div>
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary" :loading="confirmLoading">新增行</a-button>
    </div>
    <a-table
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 200 }"
    >
      <span slot="supplierIdTitle">
        <i class="toRequired">*</i>供应商
      </span>
      <span slot="needByDateTitle">
        <i class="toRequired">*</i>要求到货日期
      </span>
      <span slot="quantityTitle">
        <i class="toRequired">*</i>需求数量
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex" class="modal-table">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(tableList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :focusGet="item.focusGet ? item.focusGet : false"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label, thirdLabel: item.thirdLabel }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
            />
          </span>
          <span v-else-if="item.type === 'date'">
            <a-date-picker v-model="record[item.dataIndex]" valueFormat="YYYY-MM-DD" />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" :disabled="item.disabled" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" @change="inputNumberChange(record, item.dataIndex)" />
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiPoDeliveryNoticeLinesSplit, apiPoGetSplitDeliveryNo } from '@/api/scp/reserve-goods-plan/for-goods-manage'

export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          title: '要货单号',
          dataIndex: 'deliveryNotice',
          width: 200
        },
        {
          // title: '供应商',
          dataIndex: 'supplierId',
          scopedSlots: { customRender: 'supplierId', title: "supplierIdTitle" },
          width: 200,
          type: "select",
          focusGet: true,
          selectType: "selectSearch",
          dataList: "supplierIdList",
          requestApi: "/mdm/mdmOrgSupplier/supplierBox",
          value: 'realValue',
          label: 'label',
          thirdLabel: "selectedValue",
          searchParam: "supplierName"
        },
        {
          // title: '要求到货日期',
          dataIndex: 'needByDate',
          scopedSlots: { customRender: 'needByDate', title: "needByDateTitle" },
          width: 200,
          type: "date"
        },
        {
          // title: '需求数量',
          dataIndex: 'quantity',
          scopedSlots: { customRender: 'quantity', title: "quantityTitle" },
          width: 200,
          type: "inputNumber"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableList: [],
      detail: {},
      supplierIdList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (val) {
      const obj = { realValue: val.supplierId, label: val.supplierName, selectedValue: val.supplierName }
      const arr = []
      arr.push(obj)
      this.supplierIdList = arr

      val.needByDate = this.$moment(val.needByDate).format('YYYY-MM-DD')
      this.detail = val
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const params = {
        deliveryNotice: this.detail?.deliveryNotice,
        splitDeliveryNoticeList: arr?.map(item => item.deliveryNotice) || []
      }
      this.confirmLoading = true
      // 要货单号从后端接口拿
      apiPoGetSplitDeliveryNo(params).then(res => {
        if (res.code === 200) {
          const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
          const obj = {
            id: this.detail.id,
            deliveryNotice: res?.data || '',
            supplierId: this.detail.supplierId,
            needByDate: this.detail.needByDate,
            quantity: "",
            indexId: Number(indexId) + 1
          }
          arr.push(obj)
          this.tableList = arr
        } else {
          this.$message.error(res?.msg || '新增异常')
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      const self = this
      let flag = false
      const arr = []
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].supplierId || !this.tableList[i].needByDate) {
          this.$message.warning('必填项不能为空')
          flag = true
          return
        }
        if (!this.tableList[i].quantity) {
          this.$message.warning('需求数量 需大于0')
          flag = true
          return
        }
        if (this.detail.fixedLotMultiplier) {
          if (this.tableList[i].quantity % this.detail.fixedLotMultiplier !== 0) {
            arr.push(this.tableList[i].deliveryNotice)
          }
        }
      }
      if (flag) {
        return false
      }
      if (this.detail.fixedLotMultiplier && arr.length > 0) {
        this.$confirm({
          title: "警告：拆分行数量不满足MPQ",
          content: h => <div><div>以下行数量不满足MPQ，请确认是否继续拆分？</div>{ self.mpqHtml(arr) }</div>,
          okText: '继续发布',
          cancelText: '取消',
          icon: () => <a-icon type='info-circle' class="color-2ea1ff" />,
          onOk () {
            self.continueGo()
          }
        });
        return false
      }
      if (this.detail.quantityPendingShipment < this.detail.quantityTotal) {
        this.$confirm({
          title: "警告：拆分数量要小于或等于待送货量",
          content: h => <div><div>拆分前需求量：{ self.detail.quantityPendingShipment }</div><div>拆分后需求总量：{ self.detail.quantityTotal }</div></div>,
          okText: '继续发布',
          cancelText: '取消',
          icon: () => <a-icon type='info-circle' class="color-2ea1ff" />,
          onOk () {
            self.continueGo()
          }
        });
        return false
      }
      this.continueGo()
    },
    mpqHtml (arr) {
      const htmlObj = []
      arr.forEach(element => {
        const obj = <div class="font-bold mt5">{ element }</div>
        htmlObj.push(obj)
      });
      return <div>{ htmlObj }</div>
    },
    continueGo () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      arr.forEach(element => {
        element.needByDate = `${element.needByDate} 00:00:00`
      });
      const params = {
        id: this.detail?.id,
        cancellableQuantity: this.detail?.cancellableQuantity, // 可取消数量
        quantity: this.detail?.quantity,
        splitQuantitySum: this.detail?.quantityTotal, // 拆分后总量
        itemCode: this.detail?.itemCode,
        drNo: this.detail?.drNo,
        quantityPendingShipment: this.detail?.quantityPendingShipment, // 待送货量
        splitList: arr
      }
      this.confirmLoading = true
      apiPoDeliveryNoticeLinesSplit(params).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    inputNumberChange (record, dataIndex) {
      if (dataIndex === "quantity") {
        let num = 0
        this.tableList.forEach(element => {
          if (element.quantity) {
            num = this.handleAdd(num, element.quantity)
          }
        });
        this.$set(this.detail, "quantityTotal", num)
      }
    },
    // 简单处理精度问题
    handleAdd(a, b) {
      return (Number(a) * 1000000000 + Number(b) * 1000000000) / 1000000000
    },
    setParamsHandle (record, dataIndex) {},
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 500px;
  overflow-y: scroll;
}
.modal-table{
  input{
    width: 190px;
  }
  /deep/.ant-input-number{
    width: 190px;
  }
  /deep/.ant-select{
    width: 190px;
  }
}
.font-bold{
  font-weight: bold;
}
.w150{width:150px !important;}
.color-2ea1ff{
  color: #2ea1ff !important;
}
</style>
